<template>
  <div class="bg-white shadow overflow-hidden sm:rounded-lg mb-5">
    <div class="px-4 py-3 sm:px-6">
      <h3 class="text-lg leading-6 font-medium text-gray-900">
        Projet "{{ project.title }}"
      </h3>
    </div>
    <div class="border-t border-gray-200">
      <dl>
        <div class="bg-lighter px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt class="text-sm font-medium text-gray-700">
            ID
          </dt>
          <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
            {{ project.id }}
          </dd>
        </div>
        <div class="bg-lighter px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt class="text-sm font-medium text-gray-700">
            Type
          </dt>
          <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
            {{ project.type }}
          </dd>
        </div>
        <div class="bg-lighter px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt class="text-sm font-medium text-gray-700">
            Description
          </dt>
          <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
            {{ project.description || "Aucune description disponible" }}
          </dd>
        </div>
        <div class="bg-lighter px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt class="text-sm font-medium text-gray-700">
            Date
          </dt>
          <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
            {{ project.date }}
          </dd>
        </div>
        <div class="bg-lighter px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt class="text-sm font-medium text-gray-700">
            Membre(s)
          </dt>
          <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">

            <div class="flex items-start">
              <Avatar v-for="member in project.members"
                :key="member.id"
                :image="avatar_face"
                :size="member.id === project.creator_user_id ? 'large' : 'xlarge'"
                shape="circle"
                class="p-1 mr-1"
                :style="{ 'background-color': member.color }"
                v-tooltip.top="member.username"
              />
            </div>
          </dd>
        </div>
        <!-- <div class="bg-white px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt class="text-sm font-medium text-gray-700">
            Folder(s)
          </dt>
          <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
            4
          </dd>
        </div>
        <div class="bg-lighter px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt class="text-sm font-medium text-gray-700">
            File(s)
          </dt>
          <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
            12
          </dd>
        </div> -->
      </dl>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import Avatar from "primevue/avatar/Avatar";
import AvatarGroup from "primevue/avatargroup/AvatarGroup";

import avatar_face from "~/assets/img/avatars/face-1.svg";

export default {
  name: 'ProjectDetails',
  components: {
    Avatar,
    AvatarGroup,
  },
  data: () => ({
    avatar_face: avatar_face,
  }),
  computed: {
    ...mapGetters('adminProjects', {
      project: 'getActive'
    })
  },
};
</script>

<style scoped>

</style>
